<template>
    <div class="el-main-content">
        <el-row style="width: 100%">
            <el-col :lg="7" :xl="5">
                <div
                    class="el-form-card"
                    v-loading="isLoading"
                    :element-loading-text="$t('message.other.loading')"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                >
                    <div
                        style="
                            padding: 10px 10px 5px 30px;
                            background-color: #323c49;
                        "
                    >
                        <el-row>
                            <el-col
                                :span="12"
                                style="
                                    color: #ffffff;
                                    font-weight: bold;
                                    font-size: 16px;
                                "
                            >
                                {{
                                    readonly
                                        ? 'Booking Information'
                                        : `${formText} ${$t(
                                              'form.title.booking'
                                          )}`
                                }}
                            </el-col>
                            <el-col :span="12" v-if="!isBlc">
                                <el-row>
                                    <el-col :span="24">
                                        <div
                                            style="
                                                color: #33c8b3;
                                                font-weight: bold;
                                            "
                                        >
                                            {{
                                                $t(
                                                    'form.label.generatedPINCode'
                                                )
                                            }}
                                        </div>
                                        <div
                                            style="
                                                color: #ffffff;
                                                font-weight: bold;
                                            "
                                        >
                                            {{ this.form.pinCode }}
                                        </div>
                                    </el-col>
                                    <el-col :span="24">
                                        <span
                                            v-if="!isBlc && !isWA"
                                            style="
                                                float: right;
                                                font-size: 12px;
                                                display: flex;
                                            "
                                        >
                                            <span
                                                style="
                                                    color: rgb(255, 255, 255);
                                                    font-weight: bold;
                                                    margin-right: 10px;
                                                    margin-top: 4px;
                                                    font-size: 14px;
                                                "
                                            >
                                                {{ $t('form.label.lock') }}
                                            </span>
                                            <v-switch
                                                v-model="form.isLocked"
                                                @change="isLockedChange($event)"
                                                color="yellow"
                                                hide-details
                                            />
                                        </span>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="el-form-card__body" style="padding: 0">
                        <el-form
                            ref="form"
                            class="dark-form"
                            label-position="top"
                            label-width="150px"
                            size="mini"
                            :model="form"
                            :rules="rules"
                        >
                            <el-row
                                v-if="selectedContainer.ContainerType === 'CCC'"
                            >
                                <div class="el-form-card__element-wrapper mt-3">
                                    <el-form-item prop="container">
                                        <treeselect
                                            v-model="form.container"
                                            value-format="object"
                                            class="supplier-tree-select"
                                            @select="containerSelect"
                                            :flat="true"
                                            :clearable="false"
                                            :placeholder="
                                                $t(
                                                    'form.label.selectSearchContainer'
                                                )
                                            "
                                            :options="selectedContainerTree"
                                            :normalizer="normalizer"
                                        />
                                    </el-form-item>
                                </div>
                            </el-row>

                            <el-row v-if="!editing">
                                <div class="el-form-card__element-wrapper">
                                    <div class="el-radio-list" prop="actorType">
                                        <v-radio-group v-model="form.actorType">
                                            <v-radio
                                                :label="$t('form.label.slot')"
                                                v-if="
                                                    form.container &&
                                                    form.container
                                                        .AvailableBookingTypes &&
                                                    form.container.AvailableBookingTypes.includes(
                                                        'SLOT'
                                                    ) &&
                                                    selectedContainer.ContainerType !==
                                                        'CCC'
                                                "
                                                color="success"
                                                value="SLOT"
                                                hide-details
                                            >
                                            </v-radio>
                                            <v-radio
                                                :label="$t('form.label.pass')"
                                                v-if="
                                                    form.container &&
                                                    form.container
                                                        .AvailableBookingTypes &&
                                                    form.container.AvailableBookingTypes.includes(
                                                        'PASS'
                                                    ) &&
                                                    selectedContainer.ContainerType !==
                                                        'CCC'
                                                "
                                                color="success"
                                                value="PASS"
                                                hide-details
                                            >
                                            </v-radio>
                                            <v-radio
                                                :label="$t('form.label.blc')"
                                                v-if="
                                                    form.container &&
                                                    form.container
                                                        .AvailableBookingTypes &&
                                                    form.container.AvailableBookingTypes.includes(
                                                        'BLC'
                                                    )
                                                "
                                                color="success"
                                                value="BLC"
                                                hide-details
                                            >
                                            </v-radio>
                                            <v-radio
                                                :label="
                                                    $t(
                                                        'form.label.stockBooking'
                                                    )
                                                "
                                                color="success"
                                                value="stock"
                                                v-if="inventoryItems.length"
                                                hide-details
                                            >
                                            </v-radio>
                                            <v-radio
                                                :label="
                                                    $t(
                                                        'form.label.waitingArea2'
                                                    )
                                                "
                                                v-if="
                                                    form.container &&
                                                    form.container
                                                        .AvailableBookingTypes &&
                                                    form.container.AvailableBookingTypes.includes(
                                                        'WA'
                                                    ) &&
                                                    selectedContainer.ContainerType !==
                                                        'CCC'
                                                "
                                                color="success"
                                                value="WA"
                                                hide-details
                                            >
                                            </v-radio>
                                        </v-radio-group>
                                    </div>
                                </div>
                            </el-row>

                            <el-row v-if="isWA">
                                <div class="el-form-card__element-wrapper">
                                    <v-radio-group v-model="isUserMode" row>
                                        <v-icon style="color: #c9cbcf"
                                            >person</v-icon
                                        >
                                        <v-radio
                                            :label="$t('form.title.user')"
                                            value="user"
                                            color="primary"
                                        ></v-radio>
                                        <v-icon style="color: #c9cbcf"
                                            >people</v-icon
                                        >
                                        <v-radio
                                            :label="$t('form.title.userGroup')"
                                            value="userGroup"
                                            color="primary"
                                        ></v-radio>
                                    </v-radio-group>
                                </div>
                            </el-row>

                            <div v-show="isUserMode === 'user'">
                                <el-row v-if="isSlot || isPass || isWA">
                                    <div class="el-form-card__element-wrapper">
                                        <el-form-item
                                            v-if="
                                                permissions.includes(
                                                    'USER_READ'
                                                )
                                            "
                                            prop="recipient"
                                        >
                                            <v-select
                                                :items="recipients"
                                                :readonly="readonly"
                                                item-text="Label"
                                                combobox
                                                return-object
                                                v-model="form.recipient"
                                                :label="
                                                    $t(
                                                        'form.label.recipientName'
                                                    )
                                                "
                                                dark
                                                :clearable="!readonly"
                                                prepend-icon="person_search"
                                                required
                                            >
                                            </v-select>
                                        </el-form-item>
                                    </div>
                                </el-row>

                                <el-row v-if="isSlot || isPass">
                                    <div class="el-form-card__element-wrapper">
                                        <el-form-item prop="recipientCompany">
                                            <v-text-field
                                                :label="
                                                    $t(
                                                        'form.label.recipientCompany'
                                                    )
                                                "
                                                :readonly="readonly"
                                                v-model="form.recipientCompany"
                                                prepend-icon="business"
                                                required
                                            />
                                        </el-form-item>
                                    </div>
                                </el-row>

                                <el-row v-if="isSlot || isPass">
                                    <div
                                        class="el-form-card__element-wrapper"
                                        :class="{ 'mb-6': readonly }"
                                    >
                                        <el-form-item prop="recipientPhone">
                                            <v-text-field
                                                :label="
                                                    $t(
                                                        'form.label.recipientPhone'
                                                    )
                                                "
                                                :readonly="readonly"
                                                v-model="form.recipientPhone"
                                                prepend-icon="phone"
                                                required
                                            >
                                            </v-text-field>
                                        </el-form-item>
                                    </div>
                                </el-row>
                            </div>

                            <div v-show="isUserMode === 'userGroup'">
                                <el-row>
                                    <div class="el-form-card__element-wrapper">
                                        <el-form-item prop="userGroup">
                                            <v-select
                                                :items="userGroups"
                                                :readonly="readonly"
                                                item-text="GroupName"
                                                item-value="UserGroupID"
                                                return-object
                                                v-model="form.userGroup"
                                                :label="
                                                    $t('form.title.userGroup')
                                                "
                                                dark
                                                :clearable="!readonly"
                                                prepend-icon="person_search"
                                                required
                                                combobox
                                            >
                                            </v-select>
                                        </el-form-item>
                                    </div>
                                </el-row>
                            </div>
                            <el-row
                                v-if="
                                    (isWA && isTentativeBookingEnabled) ||
                                    isSlot
                                "
                            >
                                <div class="el-form-card__element-wrapper">
                                    <el-col :span="3">
                                        <img
                                            style="
                                                width: 24px;
                                                margin-top: 25px;
                                            "
                                            src="/images/icon/ua.png"
                                        />
                                    </el-col>
                                    <el-col :span="21">
                                        <el-form-item prop="unloadingArea">
                                            <v-select
                                                :items="activeUnloadingAreas"
                                                :readonly="readonly"
                                                item-text="ShortDescription"
                                                item-value="UnloadingAreaID"
                                                combobox
                                                return-object
                                                v-model="form.unloadingArea"
                                                :label="
                                                    $t(
                                                        'form.label.unloadingArea'
                                                    )
                                                "
                                                dark
                                                :clearable="!readonly"
                                                required
                                            >
                                            </v-select>
                                        </el-form-item>
                                    </el-col>
                                </div>
                            </el-row>

                            <div v-if="isPass">
                                <el-row>
                                    <div class="el-form-card__element-wrapper">
                                        <v-select
                                            :items="uniqueGates"
                                            :label="
                                                $t(
                                                    'form.label.selectCheckpoints'
                                                )
                                            "
                                            v-model="form.gates"
                                            item-value="Name"
                                            item-text="Name"
                                            return-object
                                            clearable
                                            multiple
                                            required
                                            chips
                                            prepend-icon="flag"
                                            dark
                                        >
                                        </v-select>
                                    </div>
                                </el-row>
                            </div>

                            <div v-else>
                                <el-row v-if="unloadingAreaCheckpoints.length">
                                    <div
                                        class="el-form-card__element-wrapper el-form-card__element-wrapper--expander"
                                    >
                                        <el-form-item prop="isShowGate">
                                            <div class="el-checkbox-list">
                                                <v-checkbox
                                                    :label="
                                                        $t(
                                                            'form.label.showGates'
                                                        )
                                                    "
                                                    v-model="form.isShowGate"
                                                    color="success"
                                                    hide-details
                                                >
                                                </v-checkbox>
                                            </div>
                                        </el-form-item>
                                    </div>
                                </el-row>

                                <el-row v-else>
                                    <div
                                        class="el-form-card__element-wrapper"
                                        v-if="
                                            (isWA &&
                                                isTentativeBookingEnabled) ||
                                            isSlot
                                        "
                                    >
                                        <el-form-item>
                                            <label
                                                class="text-sm italic"
                                                style="color: #989ea6"
                                            >
                                                {{
                                                    $t(
                                                        'form.label.noGatesVisible'
                                                    )
                                                }}
                                            </label>
                                        </el-form-item>
                                    </div>
                                </el-row>

                                <div
                                    v-if="
                                        form.isShowGate &&
                                        unloadingAreaCheckpoints.length
                                    "
                                    class="form-expanded-content"
                                >
                                    <el-row>
                                        <div
                                            class="el-form-card__element-wrapper"
                                        >
                                            <h4 style="color: #989ea6">
                                                Gates - Unloading Areas
                                            </h4>
                                            <ul
                                                class="el-form-card__unOrder-list"
                                            >
                                                <li
                                                    v-for="(
                                                        gate, index
                                                    ) in unloadingAreaCheckpoints"
                                                    :key="index"
                                                >
                                                    {{ gate.Name }}
                                                </li>
                                            </ul>
                                            <h4
                                                style="color: #989ea6"
                                                v-if="isWA"
                                            >
                                                Gates - Waiting Area
                                            </h4>
                                            <ul
                                                class="el-form-card__unOrder-list"
                                                v-if="isWA"
                                            >
                                                <li
                                                    v-for="(
                                                        gate, index
                                                    ) in waitingAreaCheckpoints"
                                                    :key="index"
                                                >
                                                    {{ gate.Name }}
                                                </li>
                                            </ul>
                                        </div>
                                    </el-row>
                                </div>
                            </div>
                            <hr class="custom-divider" v-if="isWA" />

                            <el-row v-if="isWA">
                                <div class="el-form-card__element-wrapper">
                                    <el-form-item prop="supplier">
                                        <v-select
                                            class="custom-supplier-dropdown"
                                            :items="suppliers"
                                            :readonly="readonly"
                                            item-text="SupplierName"
                                            item-value="SupplierID"
                                            combobox
                                            return-object
                                            v-model="form.supplier"
                                            :label="
                                                $t('form.label.selectSupplier')
                                            "
                                            dark
                                            solo
                                            :clearable="!readonly"
                                            required
                                        >
                                        </v-select>
                                    </el-form-item>
                                </div>
                            </el-row>

                            <el-row v-if="isWA">
                                <div
                                    class="el-form-card__element-wrapper"
                                    style="margin-top: 10px"
                                >
                                    <el-col :span="24">
                                        <div
                                            style="
                                                color: #33c8b3;
                                                font-size: 12px;
                                            "
                                        >
                                            <span>{{
                                                $t(
                                                    'form.label.expectedArrivalDate'
                                                )
                                            }}</span>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <v-icon style="color: #c9cbcf"
                                            >schedule</v-icon
                                        >
                                    </el-col>
                                    <el-col :span="14">
                                        <el-date-picker
                                            id="actualArrival"
                                            v-model="form.actualArrival"
                                            type="date"
                                            format="yyyy-MM-dd"
                                            :placeholder="
                                                $t('form.label.arrival')
                                            "
                                            :picker-options="pickerOptions"
                                            class="el-date-picker-dark el-date-picker-dark--lg"
                                            style="margin-left: 5px"
                                        >
                                        </el-date-picker>
                                    </el-col>
                                    <el-col :span="4">
                                        <v-btn
                                            class="el-table-info__btn el-btn-with-input el-table-info__btn--dark"
                                            flat
                                            @click="setArrival"
                                        >
                                            {{ $t('button.text.today') }}
                                        </v-btn>
                                    </el-col>
                                </div>
                            </el-row>

                            <el-row v-if="isWA">
                                <div class="el-form-card__element-wrapper">
                                    <el-row>
                                        <el-col :span="19">
                                            <el-form-item prop="phone">
                                                <v-text-field
                                                    :label="
                                                        $t(
                                                            'form.label.driverPhoneNo'
                                                        )
                                                    "
                                                    v-model="form.phone"
                                                >
                                                </v-text-field>
                                            </el-form-item>
                                        </el-col>
                                        <el-col
                                            :span="5"
                                            style="padding-top: 5px"
                                        >
                                            <span style="color: #989ea6">
                                                {{
                                                    $t(
                                                        'form.label.languageText'
                                                    )
                                                }}</span
                                            >
                                            <el-dropdown>
                                                <span style="color: #989ea6">
                                                    {{ form.culture
                                                    }}<i
                                                        class="el-icon-caret-bottom el-icon--right"
                                                    ></i>
                                                </span>
                                                <el-dropdown-menu
                                                    slot="dropdown"
                                                >
                                                    <el-dropdown-item
                                                        @click.native="
                                                            form.culture =
                                                                'en-US'
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                'data.label.english'
                                                            )
                                                        }}
                                                        <span
                                                            class="el-flag-wrapper flag-icon flag-icon-gb"
                                                        ></span>
                                                    </el-dropdown-item>
                                                    <el-dropdown-item
                                                        @click.native="
                                                            form.culture =
                                                                'sv-SE'
                                                        "
                                                        divided
                                                    >
                                                        {{
                                                            $t(
                                                                'data.label.swedish'
                                                            )
                                                        }}
                                                        <span
                                                            class="el-flag-wrapper flag-icon flag-icon-se"
                                                        ></span>
                                                    </el-dropdown-item>
                                                </el-dropdown-menu>
                                            </el-dropdown>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-row>

                            <hr class="custom-divider" v-if="isWA" />

                            <el-row
                                v-if="!isMilkRun && !isStock && !isWA"
                                v-show="
                                    selectedContainer.ContainerType !== 'CCC'
                                "
                            >
                                <div
                                    class="el-form-card__element-wrapper el-form-card__element-wrapper--expander"
                                >
                                    <el-form-item
                                        prop="isSendInvitationMessage"
                                    >
                                        <div class="el-checkbox-list">
                                            <v-checkbox
                                                :label="
                                                    $t(
                                                        'form.label.sendInvitationMessage'
                                                    )
                                                "
                                                v-model="
                                                    form.isSendInvitationMessage
                                                "
                                                color="success"
                                                hide-details
                                            >
                                            </v-checkbox>
                                        </div>
                                    </el-form-item>
                                </div>
                            </el-row>

                            <div
                                v-if="form.isSendInvitationMessage && !isWA"
                                class="form-expanded-content"
                            >
                                <el-row v-if="!isMilkRun && !isStock">
                                    <div class="el-form-card__element-wrapper">
                                        <el-form-item prop="phone">
                                            <v-text-field
                                                :label="
                                                    $t(
                                                        'form.label.sendPinToPhone'
                                                    )
                                                "
                                                v-model="form.phone"
                                            >
                                            </v-text-field>
                                        </el-form-item>
                                    </div>
                                </el-row>
                                <el-row v-if="!isMilkRun && !isStock">
                                    <div class="el-form-card__element-wrapper">
                                        <el-row>
                                            <el-col :span="19">
                                                <el-form-item prop="email">
                                                    <v-text-field
                                                        :label="
                                                            $t(
                                                                'form.label.sendPinToEmail'
                                                            )
                                                        "
                                                        v-model="form.email"
                                                    >
                                                    </v-text-field>
                                                </el-form-item>
                                            </el-col>
                                            <el-col
                                                :span="5"
                                                style="padding-top: 5px"
                                            >
                                                <span style="color: #989ea6">
                                                    {{
                                                        $t(
                                                            'form.label.languageText'
                                                        )
                                                    }}</span
                                                >
                                                <el-dropdown>
                                                    <span
                                                        style="color: #989ea6"
                                                    >
                                                        {{ form.culture
                                                        }}<i
                                                            class="el-icon-caret-bottom el-icon--right"
                                                        ></i>
                                                    </span>
                                                    <el-dropdown-menu
                                                        slot="dropdown"
                                                    >
                                                        <el-dropdown-item
                                                            @click.native="
                                                                form.culture =
                                                                    'en-US'
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    'data.label.english'
                                                                )
                                                            }}
                                                            <span
                                                                class="el-flag-wrapper flag-icon flag-icon-gb"
                                                            ></span>
                                                        </el-dropdown-item>
                                                        <el-dropdown-item
                                                            @click.native="
                                                                form.culture =
                                                                    'sv-SE'
                                                            "
                                                            divided
                                                        >
                                                            {{
                                                                $t(
                                                                    'data.label.swedish'
                                                                )
                                                            }}
                                                            <span
                                                                class="el-flag-wrapper flag-icon flag-icon-se"
                                                            ></span>
                                                        </el-dropdown-item>
                                                    </el-dropdown-menu>
                                                </el-dropdown>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-row>
                            </div>

                            <el-row v-if="!isMilkRun && !isStock && !isWA">
                                <div class="el-form-card__element-wrapper">
                                    <el-row>
                                        <el-col :span="3">
                                            <img
                                                style="
                                                    width: 32px;
                                                    margin-top: 25px;
                                                "
                                                src="/images/icon/anpr.png"
                                            />
                                        </el-col>
                                        <el-col :span="20">
                                            <el-form-item prop="plateNo">
                                                <v-text-field
                                                    :readonly="readonly"
                                                    :label="
                                                        $t(
                                                            'form.label.vehicleNumberPlate'
                                                        )
                                                    "
                                                    v-model="form.plateNo"
                                                >
                                                </v-text-field>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="1">
                                            <v-tooltip right>
                                                <v-icon
                                                    style="
                                                        color: #33c8b3;
                                                        font-size: 20px;
                                                        margin-top: 20px;
                                                        cursor: pointer;
                                                    "
                                                    right
                                                    slot="activator"
                                                >
                                                    info
                                                </v-icon>
                                                <span
                                                    v-html="
                                                        $t(
                                                            'form.helpText.vehicleNumber'
                                                        )
                                                    "
                                                />
                                            </v-tooltip>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-row>

                            <el-row v-if="isBlc">
                                <div class="el-form-card__element-wrapper">
                                    <el-row>
                                        <el-col :span="3">
                                            <v-icon
                                                style="
                                                    color: rgb(201, 203, 207);
                                                    margin-top: 14px;
                                                "
                                                >schedule</v-icon
                                            >
                                        </el-col>
                                        <el-col :span="21">
                                            <el-form-item
                                                prop="estimatedArrival"
                                            >
                                                <el-date-picker
                                                    class="el-form-card__date-picker"
                                                    v-model="
                                                        form.estimatedArrival
                                                    "
                                                    :picker-options="
                                                        pickerOptions
                                                    "
                                                    type="date"
                                                    format="yyyy-MM-dd"
                                                    :placeholder="
                                                        $t('form.label.date')
                                                    "
                                                >
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-row>

                            <el-row v-if="isStock">
                                <div class="el-form-card__element-wrapper">
                                    <el-form-item prop="estimatedArrival">
                                        <el-date-picker
                                            class="el-form-card__date-picker"
                                            v-model="form.estimatedArrival"
                                            type="datetime"
                                            :picker-options="pickerOptions"
                                            :placeholder="$t('form.label.date')"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </el-row>

                            <div v-if="!isBlc && !isStock">
                                <el-row v-if="!isWA">
                                    <div
                                        class="el-form-card__element-wrapper"
                                        style="margin-top: 10px"
                                    >
                                        <el-row :gutter="20">
                                            <el-col :span="3">
                                                <span
                                                    class="text-sm"
                                                    style="color: #989ea6"
                                                    >{{
                                                        $t('form.label.from')
                                                    }}</span
                                                >
                                            </el-col>
                                            <el-col :span="11">
                                                <el-date-picker
                                                    style="width: 100%"
                                                    v-model="fromDate"
                                                    size="mini"
                                                    type="date"
                                                    prefix-icon=""
                                                    :clearable="false"
                                                    placeholder="Start Date"
                                                    :picker-options="
                                                        pickerOptions
                                                    "
                                                >
                                                </el-date-picker>
                                            </el-col>
                                            <el-col :span="9">
                                                <el-time-select
                                                    style="
                                                        width: 100%;
                                                        margin-left: -15px;
                                                    "
                                                    placeholder="Start time"
                                                    @change="onFromTimeChange"
                                                    v-model="fromTime"
                                                    :clearable="false"
                                                    size="mini"
                                                    :picker-options="{
                                                        format: 'HH:mm:ss',
                                                        start: '00:00',
                                                        step: timeStepper,
                                                        end: '23:30',
                                                    }"
                                                >
                                                </el-time-select>
                                            </el-col>
                                        </el-row>
                                        <el-row
                                            :gutter="20"
                                            style="margin-top: 5px"
                                        >
                                            <el-col :span="3">
                                                <span
                                                    class="text-sm"
                                                    style="color: #989ea6"
                                                    >{{
                                                        $t('form.label.to')
                                                    }}</span
                                                >
                                            </el-col>
                                            <el-col :span="11">
                                                <el-date-picker
                                                    style="width: 100%"
                                                    v-model="toDate"
                                                    size="mini"
                                                    type="date"
                                                    :clearable="false"
                                                    placeholder="End Date"
                                                    :picker-options="
                                                        pickerOptions
                                                    "
                                                >
                                                </el-date-picker>
                                            </el-col>
                                            <el-col :span="9">
                                                <el-time-select
                                                    style="
                                                        width: 100%;
                                                        margin-left: -15px;
                                                    "
                                                    placeholder="End time"
                                                    v-model="toTime"
                                                    size="mini"
                                                    :clearable="false"
                                                    :picker-options="{
                                                        start: '00:00',
                                                        step: timeStepper,
                                                        end: '23:30',
                                                    }"
                                                >
                                                </el-time-select>
                                            </el-col>
                                        </el-row>
                                        <el-row
                                            :gutter="20"
                                            v-if="!isValidDateRange"
                                        >
                                            <el-col :span="24">
                                                <span
                                                    style="
                                                        color: #e35858;
                                                        font-size: 12px;
                                                    "
                                                    >{{
                                                        $t(
                                                            'form.label.dateRangeValidationError'
                                                        )
                                                    }}</span
                                                >
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-row>

                                <hr class="border" />

                                <el-row v-if="!isMilkRun">
                                    <div class="el-form-card__element-wrapper">
                                        <el-form-item prop="comment">
                                            <v-text-field
                                                :label="
                                                    $t(
                                                        'form.label.additionalInformation'
                                                    )
                                                "
                                                :readonly="readonly"
                                                v-model="form.comment"
                                                prepend-icon="info"
                                                multi-line
                                            />
                                        </el-form-item>
                                    </div>
                                </el-row>

                                <el-row v-if="isWA">
                                    <div class="el-form-card__element-wrapper">
                                        <v-select
                                            :items="schedules"
                                            :label="
                                                $t(
                                                    'form.label.checkpointAccessSchedule'
                                                )
                                            "
                                            item-text="Description"
                                            item-value="ScheduleTemplateID"
                                            class="input-bg-light"
                                            v-model="
                                                form.DefaultCpAccessSchedule
                                            "
                                        >
                                        </v-select>
                                    </div>
                                </el-row>

                                <el-row v-if="!isMilkRun && !isWA">
                                    <div
                                        class="el-form-card__element-wrapper el-form-card__element-wrapper--expander"
                                    >
                                        <el-form-item prop="isAdvance">
                                            <div class="el-checkbox-list">
                                                <v-checkbox
                                                    :label="
                                                        $t(
                                                            'form.label.advancedSettings'
                                                        )
                                                    "
                                                    v-model="form.isAdvance"
                                                    color="success"
                                                    hide-details
                                                />
                                            </div>
                                        </el-form-item>
                                    </div>
                                </el-row>

                                <div
                                    v-if="form.isAdvance"
                                    class="form-expanded-content"
                                >
                                    <el-row>
                                        <div
                                            class="el-form-card__element-wrapper"
                                        >
                                            <el-row>
                                                <el-col :span="12">
                                                    <el-form-item
                                                        prop="maxUsageTimes"
                                                        class="form-element-with-tooltip"
                                                    >
                                                        <v-text-field
                                                            :label="
                                                                $t(
                                                                    'form.label.noOfDeliveries'
                                                                )
                                                            "
                                                            v-model="
                                                                form.noOfDeliveries
                                                            "
                                                            type="number"
                                                            :min="1"
                                                        />
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="12">
                                                    <el-form-item
                                                        prop="maxUsageTimes"
                                                        class="form-element-with-tooltip"
                                                    >
                                                        <v-text-field
                                                            :label="
                                                                $t(
                                                                    'form.label.maxUsageTimes'
                                                                )
                                                            "
                                                            :disabled="true"
                                                            style="
                                                                color: #989ea6;
                                                            "
                                                            v-model="
                                                                form.maxUsageTimes
                                                            "
                                                            type="number"
                                                            :min="0"
                                                        />
                                                        <!--
                                                    :rules="[selectedContainer.MaximumPassingsPerBooking > 0 ? maxUsageTimeRule.max : null]"-->
                                                        <v-tooltip right>
                                                            <v-icon
                                                                dark
                                                                right
                                                                slot="activator"
                                                            >
                                                                help
                                                            </v-icon>
                                                            <span
                                                                v-html="
                                                                    $t(
                                                                        'form.helpText.maxUsageTimes'
                                                                    )
                                                                "
                                                            />
                                                        </v-tooltip>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                        </div>
                                    </el-row>

                                    <el-row>
                                        <div
                                            class="el-form-card__element-wrapper"
                                        >
                                            <el-form-item
                                                prop="preFlex"
                                                class="form-element-with-tooltip"
                                            >
                                                <v-select
                                                    v-model="form.preFlex"
                                                    :items="preFlexes"
                                                    :label="
                                                        $t('form.label.preFlex')
                                                    "
                                                    dark
                                                />
                                                <v-tooltip right>
                                                    <v-icon
                                                        dark
                                                        right
                                                        slot="activator"
                                                    >
                                                        help
                                                    </v-icon>
                                                    <span
                                                        v-html="
                                                            $t(
                                                                'form.helpText.preFlex'
                                                            )
                                                        "
                                                    />
                                                </v-tooltip>
                                            </el-form-item>
                                        </div>
                                    </el-row>

                                    <el-row>
                                        <div
                                            class="el-form-card__element-wrapper"
                                        >
                                            <el-form-item
                                                prop="unloadingTimeInMins"
                                                class="form-element-with-tooltip"
                                            >
                                                <v-select
                                                    v-model="
                                                        form.unloadingTimeInMins
                                                    "
                                                    :items="unloadingTimes"
                                                    :label="
                                                        $t(
                                                            'form.label.unloadingTimeInMins'
                                                        )
                                                    "
                                                    dark
                                                />
                                                <v-tooltip right>
                                                    <v-icon
                                                        dark
                                                        right
                                                        slot="activator"
                                                    >
                                                        help
                                                    </v-icon>
                                                    <span
                                                        v-html="
                                                            $t(
                                                                'form.helpText.unloadingTimeInMins'
                                                            )
                                                        "
                                                    />
                                                </v-tooltip>
                                            </el-form-item>
                                        </div>
                                    </el-row>
                                </div>
                            </div>

                            <el-row v-if="isBlc || isStock">
                                <div
                                    class="el-form-card__element-wrapper el-form-card__element-wrapper--expander"
                                >
                                    <el-form-item prop="isAdvance">
                                        <div
                                            class="el-checkbox-list booking__check-box--express-delivery"
                                        >
                                            <v-checkbox
                                                :label="
                                                    $t(
                                                        'form.label.expressDelivery'
                                                    )
                                                "
                                                v-model="form.isExpressDelivery"
                                                color="success"
                                                hide-details
                                            >
                                            </v-checkbox>
                                        </div>
                                    </el-form-item>
                                </div>
                            </el-row>

                            <div
                                class="button-wrapper flex justify-between items-center"
                                v-if="!isMilkRun"
                            >
                                <v-btn
                                    round
                                    v-if="showUpdateBtn"
                                    color="primary"
                                    @click="submit"
                                    :disabled="
                                        !showSubmitButton ||
                                        loading ||
                                        (form.container &&
                                            form.container.ContainerType ===
                                                'CCC')
                                    "
                                    dark
                                >
                                    {{ formText }}
                                </v-btn>
                                <v-btn round color="dark" dark>
                                    {{ $t('form.button.cancel') }}
                                </v-btn>
                            </div>
                            <el-row v-if="!showSubmitButton">
                                <div class="el-form-card__element-wrapper">
                                    <div style="margin-bottom: 20px">
                                        <v-icon
                                            style="
                                                color: rgb(242 98 35);
                                                font-size: 20px;
                                                margin-right: 5px;
                                                cursor: pointer;
                                            "
                                            right
                                            slot="activator"
                                        >
                                            info
                                        </v-icon>
                                        <span
                                            style="color: rgb(200 203 207)"
                                            v-html="
                                                $t('form.label.existingBooking')
                                            "
                                        />
                                    </div>
                                </div>
                            </el-row>
                        </el-form>
                    </div>
                </div>
            </el-col>
            <el-col :lg="17" :xl="19">
                <el-row>
                    <el-col>
                        <div class="el-grid-card" style="width: 100%">
                            <el-row v-if="isStock">
                                <stc-my-loc-inventory
                                    v-if="inventoryItems.length"
                                    :items="inventoryItems"
                                    v-model="orderedItems"
                                >
                                </stc-my-loc-inventory>
                            </el-row>
                            <div v-else>
                                <el-row>
                                    <div
                                        class="el-inner-table-right-col"
                                        style="margin-bottom: 10px"
                                    >
                                        <h2
                                            class="el-form-card__inner-title mb-2"
                                        >
                                            {{
                                                $t(
                                                    'form.title.unloadingResourcesRequired'
                                                )
                                            }}
                                            <span v-if="isBlc">(at BLC)</span>
                                        </h2>

                                        <div
                                            class="el-inner-table-check-box-list"
                                        >
                                            <div class="dark-form">
                                                <div class="el-radio-list">
                                                    <v-checkbox
                                                        :label="
                                                            $t(
                                                                'form.label.forkLift'
                                                            )
                                                        "
                                                        :disabled="readonly"
                                                        class="booking__check-box--fork-lift"
                                                        color="success"
                                                        v-model="
                                                            form.requestedResources
                                                        "
                                                        value="FORKLIFT"
                                                        hide-details
                                                    >
                                                    </v-checkbox>

                                                    <v-checkbox
                                                        v-if="!isBlc"
                                                        :label="
                                                            $t(
                                                                'form.label.truck'
                                                            )
                                                        "
                                                        :disabled="readonly"
                                                        class="booking__check-box--truck"
                                                        color="success"
                                                        v-model="
                                                            form.requestedResources
                                                        "
                                                        value="TRUCK"
                                                        hide-details
                                                    >
                                                    </v-checkbox>

                                                    <v-checkbox
                                                        v-if="!isBlc"
                                                        :disabled="readonly"
                                                        :label="
                                                            $t(
                                                                'form.label.labourers'
                                                            )
                                                        "
                                                        class="booking__check-box--labourers"
                                                        color="success"
                                                        v-model="
                                                            form.requestedResources
                                                        "
                                                        value="MANPOWER"
                                                        hide-details
                                                    >
                                                    </v-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="el-inner-table-check-box-list"
                                        >
                                            <div class="dark-form">
                                                <div class="el-radio-list">
                                                    <v-checkbox
                                                        v-if="!isBlc"
                                                        :disabled="readonly"
                                                        :label="
                                                            $t(
                                                                'form.label.industrialCrane'
                                                            )
                                                        "
                                                        class="booking__check-box--crane"
                                                        color="success"
                                                        v-model="
                                                            form.requestedResources
                                                        "
                                                        value="CRANE"
                                                        hide-details
                                                    >
                                                    </v-checkbox>

                                                    <v-checkbox
                                                        :label="
                                                            $t(
                                                                'form.label.tools'
                                                            )
                                                        "
                                                        :disabled="readonly"
                                                        class="booking__check-box--tools"
                                                        color="success"
                                                        v-model="
                                                            form.requestedResources
                                                        "
                                                        value="TOOLS"
                                                        hide-details
                                                    >
                                                    </v-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-row>
                                <div
                                    class="el-table__dark-expandable el-table__modal"
                                >
                                    <stc-booking-blc-package
                                        v-for="packageGroup in packageGroups"
                                        :key="
                                            packageGroup.PackageGroupID ||
                                            packageGroup.id
                                        "
                                        :data-blc-package="packageGroup"
                                        :actor="actor"
                                        :readonly="readonly"
                                        :suppliers="suppliers"
                                        @delete-blc-package="deletePackage"
                                    >
                                    </stc-booking-blc-package>

                                    <div class="el-row" v-if="!isMilkRun">
                                        <div class="el-bottom-btn-panel">
                                            <v-btn
                                                class="el-table-info__btn el-table-info__btn--lg el-table-info__btn--primary"
                                                flat
                                                @click="addPackage"
                                            >
                                                {{
                                                    $t(
                                                        'modal.button.addPackageGroup'
                                                    )
                                                }}
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="isWA">
                                <el-row>
                                    <el-col :span="1">
                                        <v-switch
                                            v-model="isTentativeBookingEnabled"
                                            color="yellow"
                                            hide-details
                                        />
                                    </el-col>
                                    <el-col :span="5" style="padding-top: 5px">
                                        <span style="color: #989ea6">
                                            {{
                                                $t(
                                                    'form.label.createTentativeBooking'
                                                )
                                            }}
                                        </span>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-col>
                    <el-col v-if="isWA && isTentativeBookingEnabled">
                        <div>
                            <stc-day-calendar
                                :currentActorId="actor.ActorID"
                            ></stc-day-calendar>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import StcPassword from '../Password'
import StcBookingBlcPackage from './BookingBlcPackage'
import DayCalendar from '../waiting-area-tool/DayCalendar.vue'
import InteractWithActor from '../../mixins/interact-with-actor'
import Treeselect from '@riophae/vue-treeselect'
import moment from 'moment'

import UnloadingAreasMixin from '../../mixins/unloading-areas-mixin'
import BlcMixin from '../../mixins/blc-mixin'
import GatesMixin from '../../mixins/gates-mixin'
import RecipientsMixin from '../../mixins/recipients-mixin'
import SchedulesMixin from '../../mixins/schedules-mixin'
import SupplierMixin from '../../mixins/supplier-mixin'
import UserGroupsMixin from '../../mixins/user-groups-mixin'
import DatesMixin from '../../mixins/interact-with-dates'
import { Constants } from '../../constants'

const MyLocInventory = () => import('./MyLocInventory')

export default {
    name: 'booking-create',

    props: {
        isEditable: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: undefined,
        },
        dateRange: {
            type: Array,
            default: undefined,
        },
        selectedUnloadingArea: {
            type: Object,
            default: undefined,
        },
        isBlcWorkflow: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            readonly: false,
            showAddMaterials: false,
            actor: '',
            editing: false,
            loading: false,
            preFlexes: [0, 5, 10, 15, 20, 30],
            unloadingTimes: [0, 15, 20, 25, 30, 40, 50, 60, 90, 120],
            form: {
                actorType: 'SLOT',
                container: null,
                culture: 'sv-SE',
                recipient: null,
                recipientName: '',
                recipientPhone: '',
                recipientCompany: '',
                firstName: '',
                lastName: '',
                pinCode: '',
                plateNo: '',
                unloadingArea: null,
                inGate: '',
                isLocked: false,
                outGate: '',
                gates: [],
                dateTimeRange: [],
                estimatedArrival: DateTime.local().endOf('day').toJSDate(),
                schedule: {
                    Description: '',
                    ScheduleParts: [
                        {
                            ValidFrom: null,
                            ValidTo: null,
                            WeekStart: 0,
                            WeekStop: 0,
                            IsSimpleSchedule: true,
                        },
                    ],
                },
                allowApp: true,
                company: '',
                phone: '',
                email: '',
                comment: '',
                maxUsageTimes: 1,
                noOfDeliveries: 1,
                preFlex: 0,
                isSendInvitationMessage: false,
                isShowGate: false,
                isAdvance: false,
                isExpressDelivery: false,
                unloadingTimeInMins: 0,
                requestedResources: [],
                estimatedArrival: DateTime.local().endOf('day').toJSDate(),
                actualArrival: '',
                supplier: null,
                userGroup: '',
                DefaultCpAccessSchedule: '',
            },
            packageGroups: [],
            inventoryItems: [],
            orderedItems: [],
            isUserMode: 'user',
            normalizer(node) {
                let data = {
                    id: node.ContainerID,
                    label: node.Description,
                }

                if (node.Children && node.Children.length) {
                    return {
                        ...data,
                        children: node.Children,
                    }
                }

                return data
            },
            maxUsageTimeRule: {
                max: (v) =>
                    v < this.selectedContainer.MaximumPassingsPerBooking ||
                    this.$t('form.validation.invalidMaxUsageTimes', {
                        number: this.selectedContainer
                            .MaximumPassingsPerBooking,
                    }),
            },
            onLoadGeneratePassword: false,
            showUpdateBtn: true,
            showSubmitButton: true,
            fromDate: '',
            toDate: '',
            fromTime: '00:00',
            toTime: '00:30',
            timeStepper: '00:30',
            isValidDateRange: true,
            defaultTimeStep: 15,
            isTentativeBookingEnabled: true,
            showTentativeBookingEnabled: false,
            isWA: false,
            WANotificationStatus: 0,
            isLoading: false,
            CCCContainer: null,
            waitingAreas: [],
            waitingAreaCheckpoints: [],
        }
    },

    created: async function () {
        this.CCCContainer = await this.getCCCContainerId(this.selectedContainer)
        this.reset()

        // Create booking via Material Manager flow
        if (this.isBlcWorkflow) {
            this.form.actorType == 'BLC'
        }

        this.form.actualArrival = this.getRoundedOffDate()
        this.form.container = { ...this.selectedContainer }

        if (this.form.container.ContainerType !== 'CCC') {
            this.isLoading = true

            this.form.waitingArea = this.selectedContainer.DefaultWaitingArea
            if (this.form.waitingArea) {
                await this.fetchWaitingAreas()
                const area = this.waitingAreas.filter(
                    (area) => area.WaitingAreaID === this.form.waitingArea
                )
                if (area && area.length > 0) {
                    this.waitingAreaCheckpoints = await this.getGatesByIds(
                        area[0].Checkpoints
                    )
                }
            }

            await this.fetchSuppliers()
            await this.fetchUserGroups()
            await this.getContainerBlcData()
            await this.getUnloadingAreas()
            this.getGates()
            this.fetchMyLocInventory()
            await this.getRecipients()
            await this.getSchedules()

            // Set default checkpoint Access Schedules
            if (this.form.container.DefaultCpAccessSchedule) {
                this.form.DefaultCpAccessSchedule = this.schedules.filter(
                    (it) =>
                        it.ScheduleTemplateID ==
                        this.form.container.DefaultCpAccessSchedule
                )[0]
            }
        }

        if (
            this.form.container.AvailableBookingTypes &&
            this.form.container.AvailableBookingTypes.length === 1
        ) {
            this.form.actorType = this.form.container.AvailableBookingTypes[0]
        }

        // Edit mode or Create mode
        if (this.isEditable && this.data) {
            this.onLoadGeneratePassword = false
            this.reset()

            this.editing = true
            this.readonly = false

            // WA Notification Edit
            if (this.data.event_type === 'WA_NOTIFICATION') {
                this.form.waitingArea = this.data.WaitingAreaID
                this.isWA = true
                this.isTentativeBookingEnabled = this.data.Status !== 3
                this.form.isLocked = false
                this.form.actorType = 'WA'
                this.form.WANotificationStatus = this.data.Status
                this.form.isExpressDelivery = this.data.IsExpress
                this.form.comment = this.data.Instructions

                this.suppliers.forEach((supplier) => {
                    if (supplier.SupplierID === this.data.SupplierId) {
                        this.form.supplier = supplier
                        return
                    }
                })

                if (this.data.RecipientUserGroupID) {
                    this.isUserMode = 'userGroup'
                    this.form.userGroup = _.find(this.userGroups, {
                        UserGroupID: this.data.RecipientUserGroupID,
                    })
                }

                if (this.data.RecipientUserID) {
                    this.isUserMode = 'user'
                    this.form.recipient = _.find(this.recipients, {
                        UserID: this.data.RecipientUserID,
                    })
                }

                // Update Day Calendar
                if (this.data.ActualArrival) {
                    this.form.actualArrival = DateTime.fromISO(
                        this.data.ActualArrival,
                        { zone: 'utc' }
                    ).toJSDate()
                    Events.$emit(
                        'fetch-calendar-data',
                        this.destinationContainer,
                        this.unloadingAreas,
                        null,
                        this.form.actualArrival
                    )
                }

                if (this.data.EstimatedArrival) {
                    this.form.estimatedArrival = DateTime.fromISO(
                        this.data.EstimatedArrival,
                        { zone: 'utc' }
                    ).toJSDate()
                    if (!this.data.ActualArrival) {
                        this.form.actualArrival = this.form.estimatedArrival
                    }
                }
            } else {
                if (
                    this.data.AccessSets &&
                    this.data.AccessSets.length > 0 &&
                    this.data.AccessSets[0].RecipientName
                ) {
                    this.form.recipient = _.find(this.recipients, {
                        FirstName:
                            this.data.AccessSets[0].RecipientName.split(' ')[0],
                    })
                }
            }

            this.actor = await this.fetchActorByID(this.data['ActorID'])
            if (this.actor.ActorType === 'MILKRUN') {
                this.readonly = true
            }

            this.fillFormActor(this.actor)
            this.updateDayCalendar()

            let gates = this.actor.AccessSets.map((accessSet) =>
                _.find(this.uniqueGates, {
                    CheckpointID: accessSet['CheckPointID'],
                })
            )

            this.form.gates = [...gates]
            this.actor.AccessSets.forEach((accessSet) => {
                this.fillFormAccessSet(accessSet)
            })

            this.form.isSendInvitationMessage = _.some(
                [this.form.email, this.form.phone],
                (val) => val && val.length
            )
            this.form.isAdvance = _.some(
                [this.form.preFlex, this.form.unloadingTimeInMins],
                (val) => val > 0
            )
        } else {
            this.generatePassword()
        }

        if (!this.isWA) {
            // Create booking by calendar 'slot click' or 'drag and click'
            if (this.dateRange && this.dateRange.length === 2) {
                this.processTimeStepper()
                this.showDateInPickers([
                    moment(this.dateRange[0]),
                    moment(this.dateRange[1]),
                ])
            } else {
                this.initializeDateRange()
            }
        }

        this.$nextTick(() => {
            this.isLoading = false
            this.$forceUpdate()
            this.showDefaultPackage()
        })
    },
    updated() {
        if (this.selectedUnloadingArea) {
            this.form.unloadingArea = this.selectedUnloadingArea
        }
    },
    mounted() {
        this.$refs.password && this.$refs.password.generate()

        if (this.selectedContainer.ContainerType === 'CCC') {
            this.form.actorType = 'BLC'
            this.form.estimatedArrival = moment()
                .endOf('day')
                .subtract(1, 'milliseconds')
                .toDate()
        }

        Events.$on('actor-add-packages', () => {
            if (!this.packageGroups.length) {
                this.addPackage()
            }
        })

        Events.$on('generate-password', () => {
            this.$refs.password && this.$refs.password.generate()
        })

        Events.$on('actor-editing', async (data) => {
            this.reset()

            this.editing = true
            this.readonly = false

            this.actor = await this.fetchActorByID(data['ActorID'])

            if (this.actor.ActorType === 'MILKRUN') {
                this.readonly = true
            }

            this.fillFormActor(this.actor)

            let gates = this.actor.AccessSets.map((accessSet) =>
                _.find(this.uniqueGates, {
                    CheckpointID: accessSet['CheckPointID'],
                })
            )

            this.form.gates = [...gates]
            this.actor.AccessSets.forEach((accessSet) => {
                this.fillFormAccessSet(accessSet)
            })

            this.form.isSendInvitationMessage = _.some(
                [this.form.email, this.form.phone],
                (val) => val && val.length
            )
            this.form.isAdvance = _.some(
                [this.form.preFlex, this.form.unloadingTimeInMins],
                (val) => val > 0
            )
        })

        Events.$on('actor-creating', (range) => {
            this.reset()

            this.showDateInPickers(range)
        })

        Events.$on('actor-reset', () => {
            this.reset()
        })

        Events.$on('actor-update', (validFrom, validTo) => {
            this.actorValidFrom = validFrom
            this.actorValidTo = validTo
        })

        Events.$on('update-overlapping-status', (value) => {
            this.showSubmitButton = !value
        })
    },

    beforeDestroy() {
        Events.$off('set-supplier')
    },

    mixins: [
        InteractWithActor,
        UnloadingAreasMixin,
        BlcMixin,
        GatesMixin,
        RecipientsMixin,
        SchedulesMixin,
        SupplierMixin,
        UserGroupsMixin,
        DatesMixin,
    ],

    components: {
        'stc-my-loc-inventory': MyLocInventory,
        'stc-password': StcPassword,
        'stc-booking-blc-package': StcBookingBlcPackage,
        'stc-day-calendar': DayCalendar,
        treeselect: Treeselect,
    },

    watch: {
        'form.noOfDeliveries': function (noOfDeliveries) {
            if (this.form.actorType === 'PASS') {
                if (this.form.gates && this.form.gates.length > 0) {
                    this.form.maxUsageTimes =
                        noOfDeliveries * this.form.gates.length
                } else {
                    this.form.maxUsageTimes = noOfDeliveries
                }
            } else {
                if (
                    this.form.unloadingArea.MaxPassages &&
                    this.form.unloadingArea.MaxPassages > 0
                ) {
                    this.form.maxUsageTimes =
                        noOfDeliveries * this.form.unloadingArea.MaxPassages
                } else {
                    if (this.form.unloadingArea.Checkpoints) {
                        this.form.maxUsageTimes =
                            noOfDeliveries *
                            this.form.unloadingArea.Checkpoints.length
                    } else {
                        this.form.maxUsageTimes = noOfDeliveries
                    }
                }
            }
        },

        'form.unloadingArea': function (unloadingArea) {
            if (unloadingArea.MaxPassages && unloadingArea.MaxPassages > 0) {
                this.form.maxUsageTimes =
                    this.form.noOfDeliveries * unloadingArea.MaxPassages
            } else {
                if (unloadingArea.Checkpoints) {
                    this.form.maxUsageTimes =
                        this.form.noOfDeliveries *
                        unloadingArea.Checkpoints.length
                } else {
                    this.form.maxUsageTimes = this.form.noOfDeliveries
                }
            }
            if (unloadingArea && this.form.actorType === 'WA') {
                // Update Day Calendar
                this.$nextTick(() => {
                    this.updateDayCalendar()
                })
            }
        },

        'form.gates': function (gates) {
            if (this.form.actorType === 'PASS') {
                if (gates && gates.length > 0) {
                    this.form.maxUsageTimes =
                        this.form.noOfDeliveries * gates.length
                } else {
                    this.form.maxUsageTimes = this.form.noOfDeliveries
                }
            }
        },

        'form.actualArrival': _.debounce(function () {
            const currentDate = this.getRoundedOffDate()
            this.form.actualArrival.setMilliseconds(
                currentDate.getMilliseconds()
            )
            this.form.actualArrival.setSeconds(currentDate.getSeconds())
            this.form.actualArrival.setMinutes(currentDate.getMinutes())
            this.form.actualArrival.setHours(currentDate.getHours())
            this.updateDayCalendar()
        }, 200),

        fromDate: function (value) {
            if (value) {
                this.validateDateRange()
            }
        },

        fromTime: function (value) {
            if (value) {
                this.validateDateRange()
            }
        },

        toDate: function (value) {
            if (value) {
                this.validateDateRange()
            }
        },

        toTime: function (value) {
            if (value) {
                this.validateDateRange()
            }
        },

        'form.isAdvance': function (isAdvance) {
            if (!isAdvance) {
                this.form.preFlex = 0
                this.form.maxUsageTimes = 1
                this.form.unloadingTimeInMins = 0
            }
        },

        'form.actorType': function (newVal) {
            this.isWA = false

            if (newVal == 'SLOT') {
                this.form.requestedResources = []
                this.form.isExpressDelivery = false
                this.isUserMode = 'user'
            }

            if (newVal == 'PASS') {
                this.form.unloadingArea = ''
                this.form.requestedResources = []
                this.form.isExpressDelivery = false
                this.isUserMode = 'user'
            }

            if (newVal == 'BLC') {
                this.form.unloadingArea = ''
                this.form.requestedResources = []
                this.form.isExpressDelivery = false
                this.form.recipientName = ''
                this.form.recipientCompany = ''
                this.form.recipientPhone = ''
                this.isUserMode = 'user'
            }

            if (newVal == 'WA' || newVal == 'TENTATIVE') {
                this.isWA = true
            }
        },

        isTentativeBookingEnabled: function (val) {
            // if (val && this.form.actorType === 'WA') {
            //     // Update Day Calendar
            //     this.$nextTick(() => {
            //         this.updateDayCalendar()
            //     })
            // }
        },

        'form.recipient': function (recipient) {
            if (_.isObject(recipient)) {
                this.form.recipientName =
                    recipient.FirstName + ' ' + recipient.LastName
                this.form.recipientCompany = recipient.Company
                this.form.recipientPhone = recipient.Phone
            } else {
                this.form.recipientName = recipient
            }
        },

        'form.supplier': function (supplier) {
            Events.$emit('set-supplier', supplier)
        },

        selectedContainer() {
            if (this.editing) {
                this.reset()
            }
            this.fetchMyLocInventory()
        },
    },

    computed: {
        ...mapGetters(['permissions', 'selectedContainer', 'containers']),

        selectedContainerTree() {
            return [this.selectedContainer]
        },

        unloadingAreaCheckpoints() {
            if (!this.form.unloadingArea) return []

            return this.form.unloadingArea.Checkpoints.map((id) => {
                return _.find(this.gates, { CheckpointID: id })
            })
        },

        formText() {
            return this.editing
                ? this.$t('form.title.update')
                : this.$t('form.title.create')
        },

        actorPayload() {
            let form = _.cloneDeep(this.form)

            let accessSets = []

            if (this.isPass) {
                accessSets = this.buildAccessSet(form)
            } else {
                accessSets = this.buildAccessSetWithoutGates(form)
            }

            accessSets.forEach((set) => {
                if (this.isUserMode === 'userGroup') {
                    set.RecipientCompany = null
                    set.RecipientName = null
                    set.RecipientPhone = null
                }
            })

            return {
                ActorType: this.form.actorType,
                Email: this.form.email,
                FirstName: this.form.firstName,
                LastName: this.form.lastName,
                MAIsEnabled: this.form.allowApp,
                Comment: this.form.comment,
                PinCode: this.form.pinCode,
                PlateNo: this.form.plateNo,
                Phone: this.form.phone,
                Company: this.form.company,
                Culture: this.form.culture,
                LocationValidationDisabled: true,
                MaxUsageTimes: this.isWA ? 0 : this.form.maxUsageTimes,
                NoOfDeliveries: this.form.noOfDeliveries,
                UnloadingTimeInMins: this.form.unloadingTimeInMins,
                AccessSets: accessSets,
                PackageGroups: this.packageGroups,
                IsLocked: this.form.isLocked,
            }
        },

        blcPayload() {
            let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

            const estimatedArrival = DateTime.fromISO(
                moment(this.form.estimatedArrival)
                    .endOf('day')
                    .subtract(1, 'milliseconds')
                    .toDate()
                    .toISOString()
            ).toFormat(dateTimeFormat)

            return {
                DestinationContainerID: this.form.container.ContainerID,
                EstimatedArrival: estimatedArrival,
                PinCode: this.form.pinCode,
                PlateNo: this.form.plateNo,
                Email: this.form.email,
                Phone: this.form.phone,
                IsExpress: this.form.isExpressDelivery,
                RequestedResources: this.form.requestedResources,
                BlcCheckpointID: this.containerBlcData.CheckpointID,
                BlcUnloadingAreaID: this.containerBlcData.UnloadingAreaID,
                BlcContainerID: this.containerBlcData.ContainerID,
                PackageGroups: this.packageGroups,
            }
        },

        isSlot() {
            return this.form.actorType == 'SLOT'
        },

        isBlc() {
            return this.form.actorType == 'BLC'
        },

        isStock() {
            return this.form.actorType == 'stock'
        },

        isMilkRun() {
            return this.form.actorType == 'MILKRUN'
        },

        isPass() {
            return this.form.actorType == 'PASS'
        },

        hasPackageItems() {
            return (
                this.packageGroups.length > 0 &&
                _.every(this.packageGroups, (group) => {
                    return group.PackageItems.length > 0
                })
            )
        },

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },

        rules() {
            const rules = {
                actorType: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.slot'),
                        }),
                        trigger: 'blur',
                    },
                ],
                pinCode: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.pinCodeForDriver'),
                        }),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[0-9]{6}$/,
                        message: this.$t('form.validation.minNumberDigits', {
                            name: this.$t('form.label.pinCodeForDriver'),
                            number: 6,
                        }),
                        trigger: 'blur,change',
                    },
                ],
                recipient: [
                    {
                        required: this.isUserMode === 'user',
                        message: this.$t(
                            'form.validation.selectRequiredOrEnter',
                            {
                                name: this.$t('form.label.recipientName'),
                            }
                        ),
                        trigger: 'blur',
                    },
                ],
                recipientCompany: [
                    {
                        required: this.isUserMode === 'user',
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.recipientCompany'),
                        }),
                        trigger: 'blur',
                    },
                ],
                recipientPhone: [
                    {
                        required: this.isUserMode === 'user',
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.recipientPhone'),
                        }),
                        trigger: 'blur',
                    },
                ],
                unloadingArea: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.unloadingArea'),
                        }),
                        trigger: 'blur',
                    },
                ],
                inGate: [
                    {
                        required: true,
                        message: this.$t('form.validation.selectRequired', {
                            name: this.$t('form.label.entranceGate'),
                        }),
                        trigger: 'blur',
                    },
                ],
                outGate: [
                    {
                        required: true,
                        message: this.$t('form.validation.selectRequired', {
                            name: this.$t('form.label.exitGate'),
                        }),
                        trigger: 'blur',
                    },
                ],
                email: [
                    {
                        type: 'email',
                        message: this.$t('form.validation.valid', {
                            name: this.$t('form.label.email'),
                        }),
                        trigger: 'blur,change',
                    },
                ],
                estimatedArrival: [
                    {
                        required: true,
                        message: this.$t('form.validation.selectRequired', {
                            name: 'date',
                        }),
                        trigger: 'blur',
                    },
                ],
                userGroup: [
                    {
                        required: this.isUserMode === 'userGroup',
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.title.userGroup'),
                        }),
                        trigger: 'blur',
                    },
                ],
                supplier: [
                    {
                        required: true,
                        message: this.$t('form.validation.required', {
                            name: this.$t('form.label.supplierName'),
                        }),
                        trigger: 'blur',
                    },
                ],
            }

            Vue.nextTick(() => this.$refs.form.clearValidate())

            return rules
        },
    },

    methods: {
        onFromTimeChange(currentTime) {
            if (currentTime && currentTime.includes(':')) {
                let timeArr2 = currentTime.split(':')
                let hour2 = timeArr2[0]
                let minutes2 = timeArr2[1]

                // If edit mode add difference of selected time in minutes
                let minutesToAdded
                if (this.isEditable && this.data) {
                    minutesToAdded = moment
                        .duration(
                            moment(this.dateRange[1]).diff(
                                moment(this.dateRange[0])
                            )
                        )
                        .asMinutes()
                } else {
                    if (this.selectedContainer.MinimumBookingTime === 0) {
                        minutesToAdded = this.defaultTimeStep
                    } else {
                        minutesToAdded =
                            this.selectedContainer.MinimumBookingTime
                    }
                }

                this.toTime = moment({ hours: hour2, minutes: minutes2 })
                    .add(minutesToAdded, 'minutes')
                    .format('HH:mm')
            }
        },
        showDateInPickers(dateRange) {
            this.dateTimeRange = dateRange
            let sdt = dateRange[0]
            let edt = dateRange[1]

            let sd = sdt.toDate()
            sd.setHours(0)
            sd.setMinutes(0)
            sd.setSeconds(0)

            let ed = edt.toDate()
            ed.setHours(0)
            ed.setMinutes(0)
            ed.setSeconds(0)

            this.fromDate = sd
            this.toDate = ed

            this.fromTime = this.addLeadingZeros(sdt.hour(), sdt.minutes())
            this.toTime = this.addLeadingZeros(edt.hour(), edt.minutes())
        },
        // Initialize the date range pickers
        initializeDateRange() {
            let date = new Date()
            date.setHours(0)
            date.setMinutes(0)
            date.setSeconds(0)
            // Set default from date and to date
            this.fromDate = date
            this.toDate = date

            let minimumStep = this.processTimeStepper()

            // Set default from time and to time (rounded off to the time stepper)
            let t = moment()
            let et = moment(
                Math.ceil(+t / moment.duration(minimumStep, 'minutes')) *
                    moment.duration(minimumStep, 'minutes')
            )
            this.toTime = this.addLeadingZeros(et.hour(), et.minutes())
            let st = et.subtract(minimumStep, 'minutes')
            this.fromTime = this.addLeadingZeros(st.hour(), st.minutes())
        },
        processTimeStepper() {
            let minimumStep = this.selectedContainer.MinimumBookingTime
            if (minimumStep === 0) {
                minimumStep = this.defaultTimeStep
            }
            this.timeStepper = '00:' + minimumStep
            return minimumStep
        },
        addLeadingZeros(hour, minutes) {
            let fh, fm
            if (hour >= 0 && hour <= 9) {
                fh = '0' + hour
            } else {
                fh = hour
            }
            if (minutes >= 0 && minutes <= 9) {
                fm = '0' + minutes
            } else {
                fm = minutes
            }
            return fh + ':' + fm
        },
        // Validate selected date range
        validateDateRange() {
            if (
                !this.fromDate ||
                !this.toDate ||
                !this.fromTime ||
                !this.toTime
            ) {
                this.isValidDateRange = false
                return
            }

            let finalFromDate
            let finalToDate

            let timeArr1 = this.fromTime.split(':')
            let hour1 = timeArr1[0]
            let minutes1 = timeArr1[1]
            finalFromDate = moment(this.fromDate, 'MM-DD-YYYY')
                .add(hour1, 'hours')
                .add(minutes1, 'minutes')

            let timeArr2 = this.toTime.split(':')
            let hour2 = timeArr2[0]
            let minutes2 = timeArr2[1]
            finalToDate = moment(this.toDate, 'MM-DD-YYYY')
                .add(hour2, 'hours')
                .add(minutes2, 'minutes')

            if (!finalFromDate.isBefore(finalToDate)) {
                this.isValidDateRange = false
                this.dateTimeRange = []
            } else {
                this.isValidDateRange = true
                this.dateTimeRange = [finalFromDate, finalToDate]
                this.form.estimatedArrival = finalFromDate
            }
        },
        isLockedChange(value) {
            if (
                this.permissions.includes('SUPER_USER') ||
                this.actor.LockedByUserID === this.$auth.user().UserID
            ) {
                this.showUpdateBtn = true
                this.readonly = false
            } else {
                this.form.isLocked = !value
            }
        },
        reset() {
            if (this.$refs.form) {
                this.$refs.form.resetFields()
            }

            this.actor = ''
            this.form.actorType = 'SLOT'
            this.form.pinCode = ''
            this.form.unloadingArea = ''
            this.form.phone = ''
            ;(this.form.email = ''), (this.form.isExpressDelivery = false)
            this.form.requestedResources = []
            this.form.gates = []
            this.packageGroups = []
            this.orderedItems = []
            this.editing = false
            this.readonly = false
        },

        containerSelect(container) {
            this.reset()
            if (this.isBlcWorkflow) {
                this.form.actorType = 'BLC'
                this.showDefaultPackage()
                this.generatePassword()
            }
            if (container.ContainerType !== 'CCC') {
                this.fetchMyLocInventory(container)
                this.fetchSuppliers(container)
                this.getContainerBlcData(container)
                this.getRecipients(container)
                this.getUnloadingAreas(container)
            } else {
                this.$message({
                    type: 'warning',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'message.warning.invalidSelection',
                        {
                            selection:
                                this.$i18n.i18next.t(
                                    'table.column.destination'
                                ) +
                                ' ' +
                                this.$i18n.i18next.t('form.label.container'),
                        }
                    ),
                })
            }
        },

        async submit() {
            this.loading = true

            try {
                await this.$refs.form.validate()

                if (!this.isStock && !this.hasPackageItems) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t(
                            'message.error.noPackages'
                        ),
                    })
                    this.loading = false
                    return
                }

                if (this.isStock && !this.orderedItems.length) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.noOrders'),
                    })
                    this.loading = false
                    return
                }
                if (this.isSlot) {
                    let isOverlapped =
                        await this.isScheduleOverlappedWithUnloadingArea(
                            this.form.unloadingArea,
                            this.dateTimeRange,
                            this.actor
                        )

                    if (
                        this.selectedContainer.IsBookingCanOverlapped &&
                        isOverlapped
                    ) {
                        await this.$confirm(
                            this.$i18n.i18next.t(
                                'message.warning.bookingConflicting'
                            ),
                            'Warning',
                            {
                                confirmButtonText: this.$i18n.i18next.t(
                                    'button.text.confirm'
                                ),
                                cancelButtonText:
                                    this.$i18n.i18next.t('button.text.cancel'),
                                type: 'warning',
                            }
                        )
                    } else if (isOverlapped) {
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.bookingConflicting'
                            ),
                        })
                        this.loading = false
                        return
                    }
                }

                if (this.isStock) {
                    let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT
                    const estimatedArrival = DateTime.fromISO(
                        moment(this.form.estimatedArrival)
                            .endOf('day')
                            .subtract(1, 'milliseconds')
                            .toDate()
                            .toISOString()
                    ).toFormat(dateTimeFormat)

                    await this.$http.post(
                        `/MyLocInventory/${this.form.container.ContainerID}/Order`,
                        {
                            DestinationContainerID:
                                this.form.container.ContainerID,
                            RequestedDeliveryDate: estimatedArrival,
                            BlcCheckpointID: this.containerBlcData.CheckpointID,
                            BlcUnloadingAreaID:
                                this.containerBlcData.UnloadingAreaID,
                            BlcContainerID: this.containerBlcData.ContainerID,
                            IsExpress: this.form.isExpressDelivery,
                            Packages: this.orderedItems.map((item) => ({
                                PackageID: item.MylocPackageID,
                                PackageType: item.PackageType,
                            })),
                        }
                    )
                    this.fetchMyLocInventory()
                } else if (this.isBlc) {
                    let blcContainerID = this.containerBlcData.ContainerID

                    if (!blcContainerID) {
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.noBLC'
                            ),
                        })
                        this.loading = false
                        return
                    }

                    await this.$http.post(
                        `/BLC/${blcContainerID}/Notification`,
                        this.blcPayload
                    )
                } else if (this.isWA) {
                    let waNotificationPayload = {
                        DestinationContainerID: this.form.container.ContainerID,
                        ActualArrival: '',
                        EstimatedArrival: '',
                        UnloadingAreaID: '',
                        Instructions: this.form.comment,
                        WaitingAreaID: this.form.waitingArea,
                        RecipientUserID:
                            this.isUserMode === 'user'
                                ? this.form.recipient.UserID
                                : null,
                        RecipientUserGroupID:
                            this.isUserMode === 'userGroup' &&
                            this.form.userGroup
                                ? this.form.userGroup.UserGroupID
                                : null,
                        SupplierID: this.form.supplier
                            ? this.form.supplier.SupplierID
                            : null,
                        Images: [],
                        RelatedActorID: '',
                        IsExpress: this.form.isExpressDelivery,
                        Status: 0,
                    }

                    // Build access set using unloading area checkpoints and waiting area checkpoints
                    let accessSet = this.actorPayload.AccessSets[0]
                    const unloadingAreaCheckpointsAccessSet =
                        this.form.unloadingArea.Checkpoints.map(
                            (checkpointId) => ({
                                ...accessSet,
                                CheckPointID: checkpointId,
                                ScheduleTemplates: [],
                            })
                        )
                    const waitingAreaCheckpointAccessSet =
                        this.waitingAreaCheckpoints.map((checkpoint) => ({
                            ...accessSet,
                            Schedules: [],
                            CheckPointID: checkpoint.CheckpointID,
                            ScheduleTemplates: [
                                this.form.DefaultCpAccessSchedule
                                    .ScheduleTemplateID,
                            ],
                            UnloadingAreaID: null,
                        }))
                    this.actorPayload.AccessSets =
                        unloadingAreaCheckpointsAccessSet.concat(
                            waitingAreaCheckpointAccessSet
                        )

                    if (this.isTentativeBookingEnabled) {
                        this.actorPayload.Status = 1
                        waNotificationPayload.Status = 1
                        waNotificationPayload.UnloadingAreaID = this.form
                            .unloadingArea
                            ? this.form.unloadingArea.UnloadingAreaID
                            : null
                    } else {
                        // Prepare WA Notification payload
                        this.actorPayload.Status = 3
                        waNotificationPayload.Status = 3
                        waNotificationPayload.UnloadingAreaID =
                            this.form.container.UnloadingAreaID
                        this.actorPayload.AccessSets.forEach((accessSet) => {
                            accessSet.UnloadingAreaID =
                                this.form.container.UnloadingAreaID
                        })
                    }

                    this.actorPayload.ActorType = 'TENTATIVE'

                    // Set ValidFrom and ValidTo values
                    this.actorPayload.AccessSets.forEach((accessSet) => {
                        accessSet.Schedules.forEach((schedule) => {
                            schedule.ScheduleParts.forEach((part) => {
                                part.ValidFrom = this.actorValidFrom
                                part.ValidTo = this.actorValidTo
                            })
                        })
                    })

                    // When Expected event is edited and isTentativeBookingEnabled = true then this is a post
                    let method
                    let url
                    if (this.data && !this.data.RelatedActorID) {
                        method = 'post'
                        url = 'Actor'
                    } else {
                        // Create Actor
                        method = this.editing ? 'put' : 'post'
                        url = this.editing
                            ? `Actor/${this.actor.ActorID}`
                            : 'Actor'
                    }
                    const actorResponse = await this.$http[method](
                        url,
                        this.actorPayload
                    )

                    if (
                        !actorResponse ||
                        (!this.editing && !actorResponse.data)
                    ) {
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.general'
                            ),
                        })
                        return
                    }

                    // Prepare WA Notification payload
                    waNotificationPayload.RelatedActorID =
                        actorResponse && actorResponse.data
                            ? actorResponse.data
                            : this.actor.ActorID

                    // EXPECTED or CONFIRMED POST
                    waNotificationPayload.ActualArrival = null
                    waNotificationPayload.EstimatedArrival = moment(
                        this.form.actualArrival
                    )
                        .utc()
                        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')

                    try {
                        if (this.editing) {
                            if (
                                this.data.Status === 1 ||
                                this.data.Status === 2
                            ) {
                                waNotificationPayload.Status = this.data.Status
                            }

                            // PROPOSED event from WA Tool
                            if (this.data.ActualArrival) {
                                waNotificationPayload.ActualArrival = moment(
                                    this.form.actualArrival
                                )
                                    .utc()
                                    .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
                                if (this.data.EstimatedArrival) {
                                    waNotificationPayload.EstimatedArrival =
                                        moment(this.form.estimatedArrival)
                                            .utc()
                                            .format(
                                                'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
                                            )
                                } else {
                                    waNotificationPayload.EstimatedArrival =
                                        null
                                }
                            }
                            await this.$http.put(
                                `/WANotification/${this.data.WANotificationID}`,
                                waNotificationPayload
                            )
                        } else {
                            await this.$http.post(
                                `/WANotification`,
                                waNotificationPayload
                            )
                        }
                    } catch (error) {
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.general'
                            ),
                        })
                        return false
                    }
                } else {
                    const method = this.editing ? 'put' : 'post'
                    const url = this.editing
                        ? `Actor/${this.actor.ActorID}`
                        : 'Actor'

                    await this.$http[method](url, this.actorPayload)
                }

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.editing
                        ? this.$i18n.i18next.t('message.success.updated', {
                              section: this.$i18n.i18next.t('text.booking'),
                          })
                        : this.$i18n.i18next.t('message.success.created', {
                              section: this.$i18n.i18next.t('text.booking'),
                          }),
                })

                this.$nextTick(() => {
                    Events.$emit('booking-create-success', this.getResponse())
                })
            } catch (e) {
                console.error(e)
                if (e !== false && e !== 'cancel' && e.response.data) {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `${
                            e.response.data.Message || e.response.data
                        }.`,
                    })
                }
            }

            this.loading = false
        },

        fillFormActor(actor) {
            this.form.allowApp = actor.MAIsEnabled
            this.form.actorType = actor.ActorType || ''
            this.form.firstName = actor.FirstName || ''
            this.form.lastName = actor.LastName || ''
            this.form.company = actor.Company || ''
            this.form.email = actor.Email || ''
            this.form.phone = actor.Phone || ''
            this.form.pinCode = actor.PinCode || ''
            this.form.plateNo = actor.PlateNo || ''
            this.form.culture = actor.Culture || 'sv-SE'
            this.form.maxUsageTimes = actor.MaxUsageTimes || 1
            this.form.noOfDeliveries = actor.NoOfDeliveries || 1
            this.form.comment = actor.Comment || ''
            this.form.unloadingTimeInMins = actor.UnloadingTimeInMins || 0
            if (actor.PackageGroups && actor.PackageGroups.length > 0) {
                this.packageGroups = actor.PackageGroups
            } else {
                this.addPackage()
            }
            this.form.isLocked = actor.IsLocked
            if (this.form.isLocked) {
                this.showUpdateBtn = false
                this.readonly = true
            } else {
                this.showUpdateBtn = true
                this.readonly = false
            }
            if (
                actor.AccessSets &&
                actor.AccessSets[0].Schedules &&
                actor.AccessSets[0].Schedules.length > 0 &&
                actor.AccessSets[0].Schedules[0].ScheduleParts
            ) {
                this.actorValidFrom = DateTime.fromISO(
                    actor.AccessSets[0].Schedules[0].ScheduleParts[0].ValidFrom
                ).toFormat(this.dateTimeFormat)

                this.actorValidTo = DateTime.fromISO(
                    actor.AccessSets[0].Schedules[0].ScheduleParts[0].ValidTo
                ).toFormat(this.dateTimeFormat)
            }
        },

        fillFormAccessSet(accessSet) {
            accessSet.Schedules.forEach((schedule) => {
                schedule.ScheduleParts.forEach((part) => {
                    let direction = part.Direction.toLowerCase()

                    this.form.unloadingArea =
                        _.find(this.activeUnloadingAreas, {
                            UnloadingAreaID: accessSet['UnloadingAreaID'],
                        }) || ''

                    this.form[`${direction}Gate`] =
                        _.find(this[`${direction}Gates`], {
                            CheckpointID: accessSet['CheckPointID'],
                        }) || ''

                    this.dateTimeRange = [
                        DateTime.fromISO(part.ValidFrom).toJSDate(),
                        DateTime.fromISO(part.ValidTo).toJSDate(),
                    ]
                    this.showDateInPickers([
                        moment(part.ValidFrom),
                        moment(part.ValidTo),
                    ])

                    this.form.preFlex = part.PreFlex
                    this.form.requestedResources = _.map(
                        accessSet.RequestedResources,
                        'ResourceType'
                    )
                })
            })
        },

        notifyRangeChanged(range) {
            let start = DateTime.fromISO(range[0].toISOString())
                .startOf('day')
                .toJSDate()

            let end = DateTime.fromISO(range[1].toISOString())
                .endOf('day')
                .toJSDate()

            Events.$emit('date-range-changed', [start, end])
        },

        addPackage() {
            this.packageGroups.push({
                id: _.uniqueId(),
                Reference: '',
                OrderNo: '',
                SupplierName: '',
                SupplierID: '',
                PackageItems: [
                    {
                        Height: 0,
                        Width: 0,
                        Length: 0,
                        Weight: 0,
                        PackageType: '',
                        Description: '',
                        TrackingReference: '',
                        CustomReference: '',
                    },
                ],
            })
        },

        async deletePackage(blcPackage) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'package',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText:
                            this.$i18n.i18next.t('button.text.cancel'),
                        type: 'warning',
                    }
                )

                if (blcPackage.PackageGroupID) {
                    this.$http.delete(
                        `/Actor/${this.actor.ActorID}/PackageGroup/${blcPackage.PackageGroupID}`
                    )
                }

                let index = this.packageGroups.indexOf(blcPackage)

                this.packageGroups.splice(index, 1)
            } catch (e) {
                console.error(e)
            }
        },

        async fetchMyLocInventory(container = null) {
            container = container || this.selectedContainer

            try {
                const { data } = await this.$http.get(
                    `/MyLocInventory/${container.ContainerID}`
                )

                this.inventoryItems = data
            } catch (e) {
                this.inventoryItems = []
            }
        },

        getResponse() {
            if (this.form.actorType === 'BLC') {
                return [
                    DateTime.fromISO(this.form.estimatedArrival.toISOString())
                        .startOf('week')
                        .toJSDate(),
                    DateTime.fromISO(this.form.estimatedArrival.toISOString())
                        .endOf('week')
                        .toJSDate(),
                ]
            } else if (this.form.actorType === 'WA') {
                if (this.form.estimatedArrival) {
                    return [
                        DateTime.fromISO(
                            this.form.estimatedArrival.toISOString()
                        )
                            .startOf('week')
                            .toJSDate(),
                        DateTime.fromISO(
                            this.form.estimatedArrival.toISOString()
                        )
                            .endOf('week')
                            .toJSDate(),
                    ]
                } else {
                    return [
                        DateTime.fromISO(this.form.actualArrival.toISOString())
                            .startOf('week')
                            .toJSDate(),
                        DateTime.fromISO(this.form.actualArrival.toISOString())
                            .endOf('week')
                            .toJSDate(),
                    ]
                }
            } else {
                return [
                    DateTime.fromISO(this.dateTimeRange[0].toISOString())
                        .startOf('week')
                        .toJSDate(),
                    DateTime.fromISO(this.dateTimeRange[1].toISOString())
                        .endOf('week')
                        .toJSDate(),
                ]
            }
        },
        async setArrival(e) {
            this.form.actualArrival = this.getRoundedOffDate()
        },

        async updateDayCalendar() {
            let tempActor

            if (this.isEditable && this.actor) {
                const validFrom = DateTime.fromISO(
                    moment(
                        this.actor.AccessSets[0].Schedules[0].ScheduleParts[0]
                            .ValidFrom
                    )
                        .toDate()
                        .toISOString()
                ).toFormat(this.dateTimeFormat)
                const validTo = DateTime.fromISO(
                    moment(
                        this.actor.AccessSets[0].Schedules[0].ScheduleParts[0]
                            .ValidTo
                    )
                        .toDate()
                        .toISOString()
                ).toFormat(this.dateTimeFormat)

                tempActor = {
                    ActorID: 'tempTentativeActor',
                    UpdatedActorID: this.actor.ActorID,
                    ActorType: 'PROPOSED SLOT',
                    CurrentUnloadingAreaID:
                        this.actor.AccessSets[0].UnloadingAreaID,
                    AccessSets: [
                        {
                            UnloadingAreaID: '',
                            Schedules: [
                                {
                                    ScheduleParts: [
                                        {
                                            ValidFrom: validFrom,
                                            ValidTo: validTo,
                                        },
                                    ],
                                },
                            ],
                            ScheduleTemplates: [],
                            RequestedResources: [],
                        },
                    ],
                    PackageGroups: [],
                }
            } else {
                tempActor = this.createTemporaryActor(
                    this.selectedContainer.DefaultWATime &&
                        this.selectedContainer.DefaultWATime > 0
                        ? this.selectedContainer.DefaultWATime
                        : Constants.DefaultWATime
                )
            }

            // if (
            //     !this.isEditable ||
            //     (this.isEditable &&
            //         this.isTentativeBookingEnabled &&
            //         !this.data.RelatedActorID)
            // ) {

            // }

            // Update day calendar view
            Events.$emit(
                'fetch-calendar-data',
                this.selectedContainer,
                this.unloadingAreas,
                tempActor,
                this.form.actualArrival
            )
        },

        createTemporaryActor(destinationContainerWATime) {
            if (!destinationContainerWATime) destinationContainerWATime = 0

            const validFrom = moment(this.form.actualArrival)
            const validTo = validFrom
                .clone()
                .add(destinationContainerWATime, 'minutes')

            this.actorValidFrom = DateTime.fromISO(
                validFrom.toDate().toISOString()
            ).toFormat(this.dateTimeFormat)

            this.actorValidTo = DateTime.fromISO(
                validTo.toDate().toISOString()
            ).toFormat(this.dateTimeFormat)

            return {
                ActorID: 'tempTentativeActor',
                ActorType: 'PROPOSED SLOT',
                CurrentUnloadingAreaID: this.form.unloadingArea.UnloadingAreaID,
                AccessSets: [
                    {
                        UnloadingAreaID: '',
                        Schedules: [
                            {
                                ScheduleParts: [
                                    {
                                        ValidFrom: this.actorValidFrom,
                                        ValidTo: this.actorValidTo,
                                    },
                                ],
                            },
                        ],
                        ScheduleTemplates: [],
                        RequestedResources: [],
                    },
                ],
                PackageGroups: [],
            }
        },

        async generatePassword() {
            let { data } = await this.$http.get('Util/GeneratePin')
            this.form.pinCode = data
        },

        async getCCCContainerId(container) {
            if (!container) {
                return null
            }
            const parent = this.containers.filter(
                (it) => it.ContainerID === container.ParentContainerID
            )

            if (
                parent &&
                parent.length > 0 &&
                parent[0].ContainerType === 'CCC'
            ) {
                return parent[0]
            }
            return this.getCCCContainerId(parent[0])
        },

        showDefaultPackage() {
            if (!this.packageGroups.length || this.packageGroups.length === 0) {
                this.addPackage()
            }
        },

        async fetchWaitingAreas() {
            if (
                this.form.container &&
                this.form.container.AvailableBookingTypes &&
                this.form.container.AvailableBookingTypes.includes('WA') &&
                this.selectedContainer.ContainerType !== 'CCC' &&
                this.CCCContainer &&
                this.CCCContainer.ContainerID
            ) {
                let { data } = await this.$http.get(
                    `WaitingArea/${this.CCCContainer.ContainerID}`
                )
                this.waitingAreas = data
            }
        },
    },
}
</script>
<style>
.input-group--disabled label {
    color: #989ea6 !important;
}
.input-group--disabled input {
    color: #989ea6 !important;
}
.el-picker-panel time-select el-popper {
    z-index: 99999 !important;
}
.el-picker-panel el-date-picker el-popper {
    z-index: 99999 !important;
}

.custom-divider {
    border-top: 2px solid rgb(168, 174, 182);
    margin: 20px 0px 5px 0;
}

.application .theme--dark.input-group.input-group--solo,
.theme--dark .input-group.input-group--solo {
    border-radius: 25px;
}

.custom-supplier-dropdown .input-group__input {
    background-color: #2db4ff !important;
    border-radius: 25px;
    padding: 5px 5px;
}
.custom-supplier-dropdown label {
    color: #ffffff !important;
    font-weight: bold !important;
    margin-top: 4px;
    text-transform: uppercase;
}

.custom-supplier-dropdown .input-group__selections__comma {
    color: #ffffff !important;
    font-weight: bold !important;
}

.input-group__selections__comma {
    color: #ffffff !important;
    font-weight: bold !important;
}

.input-group--select .input-group__append-icon {
    color: #ffffff !important;
    font-weight: bold !important;
}

.custom-supplier-dropdown .input-group__details {
    display: none;
}

.theme--light
    .input-group:not(.input-group--error):not(.input-group--focused):not(
        .input-group--disabled
    )
    .input-group__input
    .input-group__prepend-icon:not(:hover) {
    color: #c9cbcf !important;
}

.el-date-picker-dark--lg .el-input__inner {
    width: 250px;
}

.custom-supplier-dropdown
    .application
    .theme--dark.input-group.input-group--dirty
    .input-group__selections__comma:not(
        .input-group__selections__comma--active
    ) {
    color: #ffffff !important;
}

.input-group--select .input-group__selections__comma {
    color: #ffffff !important;
}

.input-group.input-group--focused .input-group__append-icon {
    color: #ffffff !important;
}

.input-group--select .input-group__append-icon {
    color: #ffffff !important;
}

.application
    .theme--dark.input-group.input-group--dirty
    .input-group__selections__comma:not(
        .input-group__selections__comma--active
    ),
.theme--dark
    .input-group.input-group--dirty
    .input-group__selections__comma:not(
        .input-group__selections__comma--active
    ) {
    color: #ffffff;
}
</style>
